const filterOptions = document.querySelectorAll(".filter-option");
filterOptions.forEach(function (element) {
    element.addEventListener('click', function () {
        this.closest('.filter-option-container').classList.toggle('active');
    });
});

const searchPageElements = {
    bar: document.getElementById('search-bar-page'),
    close: document.getElementById('close-search-page'),
    input: document.getElementById('search-input-page'),
    resultsList: document.getElementById('search-page-results-list'),
    searchIcon: document.getElementById('search-action-page'),
    formSearch: document.getElementById('form-search-page'),
};

let searchPageDebounceTimer;

/**
 * Aplica debounce para evitar múltiplas requisições simultâneas
 * @param {Function} callback
 * @param {number} delay
 * @returns {Function}
 */
const debounceSearchPage = (callback, delay = 300) => {
    return (...args) => {
        clearTimeout(searchPageDebounceTimer);
        searchPageDebounceTimer = setTimeout(() => callback(...args), delay);
    };
};

/**
 * Obtém os resultados da busca
 * @param {string} query
 * @returns {Promise<Response>}
 */
const fetchSearchPageResults = async (query) => {
    const url = `${window.Shopify.routes.root}search/suggest?q=${query}&resources[type]=product&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title&section_id=organism-search-suggestion-results`;
    return fetch(url);
};

/**
 * Converte a resposta da busca em HTML
 * @param {Response} response
 * @returns {Promise<Element>}
 */
const parseSearchPageResults = async (response) => {
    const text = await response.text();
    const resultsMarkup = new DOMParser().parseFromString(text, 'text/html');
    return resultsMarkup.querySelector('#predictive-search');
};

/**
 * Atualiza a lista de resultados da busca
 * @param {Element} resultsMarkup
 */
const updateSearchPageResults = (resultsMarkup) => {
    searchPageElements.resultsList.innerHTML = '';
    searchPageElements.resultsList.appendChild(resultsMarkup);
};

const handleSearchPageInput = debounceSearchPage(async (event) => {
    const query = event.target.value.trim();
    if (!query) return;
    console.log('Buscando por:', query);
    searchPageElements.input.value = query;
    try {
        const response = await fetchSearchPageResults(query);
        if (!response.ok) throw new Error(`${response.status}: ${await response.text()}`);
        const resultsMarkup = await parseSearchPageResults(response);
        updateSearchPageResults(resultsMarkup);
        searchPageElements.resultsList.classList.replace('opacity-0', 'opacity-100');
        StoreUtils.handleScaRef('.search-result-card', false);
    } catch (error) {
        console.error('Erro na busca:', error);
    }
}, 300);

/**
 * Alterna a visibilidade da barra de pesquisa
 */
const toggleSearchPage = () => {
    const isOpen = !searchPageElements.bar.classList.contains('-top-full');

    if (isOpen) {
        searchPageElements.resultsList.classList.replace('opacity-100', 'opacity-0');
        searchPageElements.input.value = '';
        searchPageElements.resultsList.innerHTML = '';
        searchPageElements.input.blur();
        document.body.classList.remove('overflow-hidden');
    } else {
        searchPageElements.bar.classList.remove('-top-full', 'opacity-0');
        searchPageElements.bar.classList.add('m-auto', 'h-11', 'opacity-100', 'transition-all');
        document.body.classList.add('overflow-hidden');
        searchPageElements.input.focus();
    }
};

/**
 * Impede o envio do formulário se o campo de busca estiver vazio
 */
const validateAndSubmitSearchPage = (event) => {
    const query = searchPageElements.input.value.trim();
    if (!query) {
        event.preventDefault();
        searchPageElements.input.focus();
    } else {
        const form = searchPageElements.input.closest("form");
        if (form) {
            form.submit();
        }
    }
};

searchPageElements.input.addEventListener('input', handleSearchPageInput);
searchPageElements.close.addEventListener('click', toggleSearchPage);
searchPageElements.searchIcon.addEventListener('click', validateAndSubmitSearchPage);
searchPageElements.input.addEventListener('keypress', function (event) {
    if (event.key === 'Enter') {
        validateAndSubmitSearchPage(event);
    }
});
